import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import resolveCorrelationId from './additionalMessageResolver/resolveCorrelationId';
/**
 * @param error
 * @returns {Promise<string[]>}
 */

var resolveErrorSecondaryMessages = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(error) {
    var messages;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.all([resolveCorrelationId(error)]);

          case 2:
            messages = _context.sent;
            return _context.abrupt("return", messages.filter(function (message) {
              return message !== null;
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function resolveErrorSecondaryMessages(_x) {
    return _ref.apply(this, arguments);
  };
}();

export default resolveErrorSecondaryMessages;